<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd" v-if="!esModal">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Cita <span v-if="!cita._id">nueva</span></ion-title>
      <ion-buttons slot="end" v-if="!esModal">
        <ion-button v-if="!editable" @click="editable=!editable">
          <i class="icon ion-ios-create"></i>&nbsp;Editar
        </ion-button>
        <ion-button v-else @click="editable=!editable">
          <i class="icon ion-ios-checkmark-circle-outline"></i>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end" v-else>
        <ion-button @click="cerrarModal(false)">
          <i class="icon ion-ios-close-circle"></i>&nbsp;Cancelar
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-progress-bar type="indeterminate" v-if="cargando"></ion-progress-bar>
  </ion-header>
  <ion-content class="content ion-padding" color="">
    <ion-list>
      <ion-item>
        <ion-label position="stacked">Fecha y hora de la cita</ion-label>
        <ion-input :disabled="cargando" type="datetime-local" :value="cita.fecha" v-on:ionChange="set('fecha',$event.detail.value)" />
      </ion-item>
      <ion-item @click="seleccionarCliente">
        <ion-label>
          <p>Cliente</p>
          <div v-if="cita.cliente && cita.cliente._id" class="prim">
            <h2>{{cita.cliente.nombre}}</h2>
            <p>{{cita.cliente.rfc}}</p>
          </div>
          <h2 v-else>Seleccione...</h2>
        </ion-label>
        <ion-note slot="end">
          <i class="icon ion-ios-arrow-down"></i>
        </ion-note>
      </ion-item>
      <ion-item @click="seleccionarEquipo">
        <ion-label>
          <p>Equipo a revisar</p>
          <div v-if="cita.equipo && cita.equipo._id" class="prim">
            <h2 v-if="cita.equipo">{{cita.tipo}}</h2>
            <p>{{cita.equipo.marca}} {{cita.equipo.modelo}}, SN {{cita.equipo.sn}}</p>
            <p>{{cita.equipo.area}} {{cita.equipo.subarea}}</p>
          </div>
          <h2 v-else>Seleccione...</h2>
        </ion-label>
        <ion-note slot="end">
          <i class="icon ion-ios-arrow-down"></i>
        </ion-note>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Usuario asignado</ion-label>
        <ion-select :value="cita.idUsuarioAsignado" v-on:ionChange="set('idUsuarioAsignado',$event.detail.value)" :disabled="cargando">
          <ion-select-option :value="''">Seleccione...</ion-select-option>
          <ion-select-option v-for="u in usuarios" :key="u._id" :value="u._id">{{u.nombre}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label>Cita confirmada</ion-label>
        <ion-checkbox slot="end" :disabled="cargando" :checked="cita.confirmada" v-on:ionChange="cita.confirmada=($event.detail.checked==true)"></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Notas
        </ion-label>
        <ion-textarea :disabled="cargando" :value="cita.notas" v-on:ionChange="set('notas',$event.detail.value)" />
      </ion-item>
    </ion-list>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="guardar" v-if="editable">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
      <ion-fab-button color="primary" @click="irOrdenServicio" v-else>
        <i class="icon icon-lg ion-ios-flag"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<style>
.prim {
  color: #8888aa;
}
</style>
<script>
import Api from '@/components/Api/Api'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import ModalSeleccionarEquipo from '@/components/ModalSeleccionarEquipo'
import ModalSeleccionarCliente from '@/components/ModalSeleccionarCliente'
import Vue from 'vue'
Vue.component('calendar', Calendar)
//Vue.component('date-picker', DatePicker)
export default {
  name: 'Cita',
  props: {
    id: {
      type: String,
      default: '0'
    },
    esModal: {
      type: Boolean,
      default: false
    },
    modalIdEquipo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      esMovil: Api.esMovil(),
      editable: false,
      modals: {},
      cargando: false,
      cita: {
        idAutor: (Api.fetchLocal('cmms.yo') || {})._id,
        idCliente: '',
        idEquipo: '',
        idUsuarioAsignado: (Api.fetchLocal('cmms.yo') || {})._id,
        fecha: new Date(new Date().getTime() - (1000 * 60 * 60 * 6)).toISOString().substring(0, 16),
        fechaCreada: new Date().getTime(),
        notas: '',
        confirmada: true,
      },
      clientes: [],
      equiposTodos: [],
      equipos: [],
      usuarios: [],
      campos: [{
        label: 'Fecha',
        type: 'datetime-local',
        name: 'fechaProgramada'
      }, {
        label: 'Cliente',
        type: 'select',
        name: 'idCliente',
        options: []
      }, {
        label: 'Equipo a revisar',
        type: 'select',
        name: 'idEquipo',
        options: [],
      }, {
        label: 'Agente en campo',
        type: 'select',
        name: 'idUsuarioAsignado',
        options: []
      }, {
        label: 'Notas',
        type: 'text',
        name: 'notas'
      }]
    }
  },
  async mounted() {
    this.cargando = true
    await this.obtenerCatalogos()
    await this.obtener()
    console.log("cita?", this.cita)
    if (this.modalIdEquipo != '') {
      let equipo = await Api.get('equipo', this.modalIdEquipo)
      let cliente = await Api.get('cliente', equipo.idCliente)
      await Api.wait(500)
      this.cita.idCliente = cliente._id
      this.cita.cliente = cliente
      this.cita.idEquipo = equipo._id
      this.cita.equipo = equipo
      this.cita.confirmada = false
      if (!Api.modoProduccion)
        equipo.periodicidadMeses = 2
      if (equipo.periodicidadMeses && equipo.periodicidadMeses > 0)
        this.cita.fecha = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30 * equipo.periodicidadMeses)).toISOString().substring(0, 16)
      this.$forceUpdate()
      toast("Seleccionados cliente y equipo")
    }
    this.cargando = false
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    async obtenerCatalogos() {
      this.clientes = (await Api.get('cliente'))
        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
        .filter(c => c.nombre && c.nombre != '')
      this.equiposTodos = (await Api.get('equipo'))
        .sort((a, b) => a.alias > b.alias ? 1 : -1)
      this.usuarios = (await Api.get('directorio'))
        .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
      for (let i in this.campos) {
        if (this.campos[i].name == 'idCliente')
          this.campos[i].options = this.clientes
        if (this.campos[i].name == 'idUsuarioAsignado')
          this.campos[i].options = this.usuarios
        if (this.campos[i].name == 'idEquipo')
          this.campos[i].options = this.equiposTodos
      }
      await Api.wait(100)
      return Promise.resolve(true)
    },
    async obtener() {
      if (this.id && this.id.length > 1) {
        this.cita = await Api.get('cita', this.id)
        this.editable = false
      } else
        this.editable = true
      return true
    },
    set(campo, valor) {
      this.cita[campo] = valor
      console.log("set", campo, valor)
    },
    toggleEditable() {
      this.editable = !this.editable
      if (this.editable == true && this.cita._id)
        Api.save('bitacora', {
          mensaje: 'Cita en edición',
          idAutor: this.yo._id,
          idCita: this.cita._id,
          fecha: new Date().getTime()
        })
    },
    async guardar() {
      let camposFaltantes = []
      let camposRequeridos = ['fecha', 'idCliente', 'idUsuarioAsignado']
      for (let campo of camposRequeridos)
        if (!(this.cita[campo] && this.cita[campo] != ''))
          camposFaltantes.push(campo)
      if (camposFaltantes.length == 0) {
        await Api.save('cita', this.cita)
        toast("Guardado")
        await Api.wait(500)
        if (this.esModal) {
          const citaCreada = true
          this.cerrarModal(citaCreada)
        } else
          this.$router.push('/agenda')
      } else
        alert("Faltan datos: " + camposFaltantes.join(', '))
    },
    irOrdenServicio() {
      this.$router.push('/ordenes/' + this.id)
    },
    async seleccionarEquipo() {
      let vm = this
      let equipos = this.equiposTodos.filter(e => e.idCliente == vm.cita.idCliente)
      let cliente = this.clientes.filter(c => c._id == vm.cita.idCliente)[0]
      let id = 'seleccionarEquipo' + Math.random()
      console.log("ModalSeleccionarEquipo", equipos)
      if (this.cita.idCliente == '')
        alert("Debe seleccionar un cliente primero")
      else if (!this.editable)
        console.log("LOL no hago nada")
      else
        return this.$ionic.modalController
          .create({
            component: ModalSeleccionarEquipo,
            swipeToClose: true,
            componentProps: {
              parent: vm,
              propsData: {
                equipos,
                cliente
              }
            }
          })
          .then(m => {
            vm.modals[id] = m
            console.log("ModalSeleccionarEquipo", vm.modal)
            vm.modals[id].present()
            vm.modals[id].onDidDismiss(_ => {
              console.log("Modal cerrado")
              Api.$off('ModalSeleccionarEquipoCerrar')
              Api.$off('seleccionarEquipo')
            })
            Api.$on('ModalSeleccionarEquipoCerrar', _ => {
              console.log("$on modalCerrar")
              vm.modals[id].dismiss()
            })
            Api.$on('seleccionarEquipo', equipo => {
              vm.set('idEquipo', equipo._id)
              vm.cita.equipo = equipo
              toast("Equipo seleccionado: " + equipo.sn)
              vm.$forceUpdate()
              console.log("$on seleccionarEquipo", equipo.sn, equipo)
              vm.modals[id].dismiss()
            })
          })
    },
    async seleccionarCliente() {
      let vm = this
      let clientes = JSON.parse(JSON.stringify(this.clientes))
      let id = 'seleccionarCliente' + Math.random()
      console.log("ModalSeleccionarCliente", clientes)
      if (!this.editable)
        console.log("seleccionarCliente LOL no hago nada")
      else
        return this.$ionic.modalController
          .create({
            component: ModalSeleccionarCliente,
            swipeToClose: true,
            componentProps: {
              parent: vm,
              propsData: {
                clientes
              }
            }
          })
          .then(m => {
            vm.modals[id] = m
            console.log("ModalSeleccionarCliente", vm.modals[id])
            vm.modals[id].present()
            vm.modals[id].onDidDismiss(_ => {
              console.log("seleccionarCliente Modal cerrado")
              Api.$off('ModalSeleccionarClienteCerrar')
              Api.$off('seleccionarCliente')
            })
            Api.$on('ModalSeleccionarClienteCerrar', _ => {
              console.log("$on ModalSeleccionarClienteCerrar")
              vm.modals[id].dismiss()
            })
            Api.$on('seleccionarCliente', c => {
              vm.set('idCliente', c._id)
              vm.cita.cliente = c
              toast("Cliente seleccionado: " + c.nombre)
              vm.$forceUpdate()
              console.log("$on seleccionarCliente", c.nombre)
              vm.modals[id].dismiss()
              vm.seleccionarEquipo()
            })
          })
    },
    cerrarModal(citaCreada = false) {
      Api.$emit('cerrarModalCita', citaCreada)
    }
  },
  watch: {
    'cita.idCliente': function(a) {
      for (let i in this.campos)
        if (this.campos[i].name == 'idEquipo')
          this.campos[i].options = this.equiposTodos.filter(e => e.idCliente == a)
    }
  }
}
</script>
